import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Row, Col, Form, Spinner, Button, Modal } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import DataTable from "react-data-table-component";
import axios from "axios";
import Card from "../../components/Card";
import PegawaiService from "../../services/registrasi/PegawaiService";
// import faFileImage from "@fortawesome/free-solid-svg-icons/faFileImage";

const DataUserTrader = () => {
  const [traderList, setTraderList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const [showSendSuccess, setShowSendSucces] = useState(false);
  const [showSendFailed, setShowSendFailed] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const pegawaiService = useMemo(() => new PegawaiService(), []);


  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");


  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const kodeTrader = localStorage.getItem("kodeTrader");

  const initialForm = {
    KODE_TRADER:kodeTrader,
    NO_ID: "",
    EMAIL: "",
    NAMA: "",
    JABATAN: "",
    TELEPON: "",
    ALAMAT: "",
    FILE_ID: "",
    STATUS: "0",
    dokumen: [] 
  };

  const [formData, setFormData] = useState(initialForm);


  const fetchDataTrader = useCallback(async () => {
    setLoading(true);
    try {
      const res = await pegawaiService.getUserByKodeTrader(kodeTrader);
      setTraderList(Array.isArray(res.data) ? res.data : res.data?.data || []);
    } catch (error) {
      console.error("Gagal mengambil data user trader:", error);
    } finally {
      setLoading(false);
    }
  }, [pegawaiService, kodeTrader]);

  useEffect(() => {
    fetchDataTrader();
  }, [fetchDataTrader]);


  const handleAdd = async () => {
    setFormData(initialForm);
    setSelectedFile(null);
    setIsEditMode(false);
    setShowModal(true);

    try {
      const res = await pegawaiService.randomString();
      const generatedFileId = res.data.fileId || res.data;
      setFormData((prev) => ({ ...prev, FILE_ID: generatedFileId }));
    } catch (error) {
      console.error("Gagal generate FILE_ID:", error);
    }
  };


  const handleEdit = useCallback((row) => {
    setFormData({
      USER_ID: row.USER_ID || "",
      KODE_TRADER: row.KODE_TRADER || "",
      NO_ID: row.NO_ID || "",
      NAMA: row.NAMA || "",
      EMAIL: row.EMAIL || "",
      JABATAN: row.JABATAN || "",
      TELEPON: row.TELEPON || "",
      ALAMAT: row.ALAMAT || "",
      KD_UNIT: row.KD_UNIT || "",
      FILE_ID: row.FILE_ID || "",
      STATUS: row.STATUS || "0",
      dokumen: row.dokumen || []
    });
    setSelectedFile(null);
    setIsEditMode(true);
    setShowModal(true);
  }, []);

  // 4. Delete Handler
  const handleDelete = useCallback((row) => {
    setSelectedUser(row);
    setShowConfirmDelete(true);
  }, []);

  const confirmDelete = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL_REGISTER}/data/user/${selectedUser.USER_ID}`);
      fetchDataTrader();
      setShowConfirmDelete(false);
      setShowDeleteSuccess(true);
    } catch (err) {
      console.error("Gagal menghapus user:", err);
      setShowConfirmDelete(false);
    }
  };

  const handleSubmit = async () => {
    if (!formData.EMAIL || !formData.NO_ID || !formData.KODE_TRADER) {
      setAlertMsg("ID dan EMAIL wajib diisi!");
      setShowSendFailed(true);
      return;
    }

    setIsLoadingSubmit(true);

    try {
      let updatedDokumen = [...formData.dokumen];
      
      if (selectedFile && formData.FILE_ID) {
        await pegawaiService.putDokumen(formData.FILE_ID, selectedFile);
        const newPath = `${process.env.REACT_APP_API_URL_FILE}/view/${formData.FILE_ID}/${selectedFile.name}`;
        updatedDokumen.push({
          DOK_PATH: newPath
        });
      }

      const payloadToSend = {
        ...formData,
        dokumen: updatedDokumen
      };

      if (isEditMode) {
        await axios.put(`${process.env.REACT_APP_API_URL_REGISTER}/data/user/${formData.USER_ID}`, payloadToSend);
      } else {
        await pegawaiService.addUserTrader(payloadToSend);
      }

      fetchDataTrader();
      setShowModal(false);
      setShowSendSucces(true);
    } catch (err) {
      console.error("Gagal simpan data:", err);
      setAlertMsg(err.response?.data?.msg || "Gagal menyimpan data trader");
      setShowSendFailed(true);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

 
  const columns = useMemo(() => [
    { name: "Kode Trader", selector: row => row.KODE_TRADER, width: "130px", center: true },
    { name: "No ID / KTP", selector: row => row.NO_ID, width: "180px", center: true },
    { name: "Nama", selector: row => row.NAMA, width: "200px" },
    { name: "Username", selector: row => row.USERNAME, width: "220px" },
    { name: "Telepon", selector: row => row.TELEPON, width: "150px" },
    { name: "Jabatan", selector: row => row.JABATAN, width: "180px" },
    { 
      name: "Alamat", 
      selector: row => row.ALAMAT, 
      width: "250px", 
      cell: row => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>{row.ALAMAT}</div>
      )
    },
    // { name: "FILE ID", selector: row => row.FILE_ID, width: "140px", center: true },
    //  { name: "Dokumen",
    //   width: "150px",
    //   center: true,
    //   cell: row => (
    //     row.dokumen && row.dokumen.length > 0 ? (
    //       <a href={`${process.env.REACT_APP_API_URL_FILE}/download/${row.FILE_ID}`} target="_blank" rel="noopener noreferrer">
    //         <Icon icon={faFileImage} /> 
    //       </a>
    //     ) : (
    //       "Tidak ada dokumen"
    //     )
    //   )
    // },
    // { 
    //   name: "Status", 
    //   width: "120px", 
    //   center: true,
    //   cell: row => (
    //     <span className={`badge ${row.STATUS === "0" || row.STATUS === 0 ? "bg-success" : "bg-danger"}`}>
    //       {row.STATUS === "0" || row.STATUS === 0 ? "Aktif" : "Non-Aktif"}
    //     </span>
    //   )
    // },
    // {
    //   name: "Aksi",
    //   width: "180px",
    //   center: true,
    //   cell: (row) => (
    //     <>
    //       <Button variant="warning" size="sm" className="me-2" onClick={() => handleEdit(row)}>
    //         Edit
    //       </Button>
    //       <Button variant="danger" size="sm" onClick={() => handleDelete(row)}>
    //         Hapus
    //       </Button>
    //     </>
    //   ),
    // },
  ], [handleEdit, handleDelete]);

  // Filter Search Logic
  const filteredData = useMemo(() => {
    const keyword = searchKeyword.toLowerCase();
    return traderList.filter((t) => {
      return (
        (t.KODE_TRADER || "") ||
        (t.NO_ID || "").toLowerCase().includes(keyword) ||
        (t.EMAIL || "").toLowerCase().includes(keyword) ||
        (t.TELEPON || "").toLowerCase().includes(keyword)
      );
    });
  }, [traderList, searchKeyword]);

  // Pagination Logic
  const paginatedData = useMemo(() => {
    const start = page * size;
    return filteredData.slice(start, start + size);
  }, [filteredData, page, size]);

  return (
    <Row>
      <Col sm="12">
        {/* Card Filter & Actions */}
        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h4 className="card-title">Pencarian Data User</h4>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row className="align-items-end">
                <Col sm="4">
                  <Form.Group>
                    <Form.Control
                      type="text"
                      placeholder="Cari User"
                      value={searchKeyword}
                      onChange={(e) => setSearchKeyword(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col sm="2">
                  <Button variant="secondary" className="w-100" onClick={() => setSearchKeyword("")}>Reset</Button>
                </Col>
                <Col sm="2">
                  <Button variant="primary" className="w-100" onClick={handleAdd}>+ Tambah User Trader</Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        {/* Modal Form */}
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit User Trader" : "Tambah User Trader"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                {/* <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Kode Trader</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.KODE_TRADER}
                      onChange={(e) => setFormData({ ...formData, KODE_TRADER: e.target.value })}
                    />
                  </Form.Group>
                </Col> */}

                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>No. ID / KTP</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.NO_ID}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) {
                          setFormData({ ...formData, NO_ID: e.target.value });
                        }
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Nama Lengkap</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.NAMA}
                      onChange={(e) => setFormData({ ...formData, NAMA: e.target.value })}
                    />
                  </Form.Group>
                </Col>

                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Email / Username</Form.Label>
                    <Form.Control
                      type="email"
                      value={formData.EMAIL}
                      onChange={(e) => setFormData({ ...formData, EMAIL: e.target.value })}
                    />
                  </Form.Group>
                </Col>

                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>  Jabatan</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.JABATAN}
                      onChange={(e) => setFormData({ ...formData, JABATAN: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                {/* <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Password {isEditMode && "(Kosongkan jika tidak diubah)"}</Form.Label>
                    <Form.Control
                      type="password"
                      value={formData.PASSWORD}
                      onChange={(e) => setFormData({ ...formData, PASSWORD: e.target.value })}
                    />
                  </Form.Group>
                </Col> */}

                {/* <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Alamat</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.ALAMAT}
                      onChange={(e) => setFormData({ ...formData, ALAMAT: e.target.value })}
                    />
                  </Form.Group>
                </Col> */}

                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>No. Telepon</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.TELEPON}
                      onChange={(e) => setFormData({ ...formData, TELEPON: e.target.value })}
                    />
                  </Form.Group>
                </Col>

                {/* <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>FILE ID (Generated)</Form.Label>
                    <Form.Control type="text" value={formData.FILE_ID} disabled />
                  </Form.Group>
                </Col> */}

                <Col md="6">
                  <Form.Group className="mb-3">
                    <Form.Label>Upload ID</Form.Label>
                    <Form.Control
                      type="file"
                      onChange={(e) => setSelectedFile(e.target.files[0] || null)}
                    />
                    {selectedFile && (
                      <Form.Text className="text-muted">
                        File terpilih: {selectedFile.name}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

                <Col md="12">
                  <Form.Group className="mb-3">
                    <Form.Label>Alamat</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={formData.ALAMAT}
                      onChange={(e) => setFormData({ ...formData, ALAMAT: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Batal</Button>
            <Button variant="primary" onClick={handleSubmit} disabled={isLoadingSubmit}>
              {isLoadingSubmit ? <Spinner size="sm" animation="border" /> : "Simpan Data"}
            </Button>
          </Modal.Footer>
        </Modal>

        {showSendSuccess && (
          <SweetAlert success title="Berhasil" onConfirm={() => setShowSendSucces(false)} btnSize="sm">
            Data User Trader berhasil disimpan silahkan login dengan username email yang telah Anda daftarkan.
          </SweetAlert>
        )}
        {showSendFailed && (
          <SweetAlert danger title="Gagal Simpan" onConfirm={() => setShowSendFailed(false)} btnSize="sm">
            {alertMsg || "Terjadi kesalahan saat menyimpan data."}
          </SweetAlert>
        )}
        {showConfirmDelete && (
          <SweetAlert
            warning
            showCancel
            confirmBtnText="Ya, hapus"
            cancelBtnText="Batal"
            confirmBtnBsStyle="danger"
            title={`Hapus Trader: ${selectedUser?.KODE_TRADER}?`}
            onConfirm={confirmDelete}
            onCancel={() => setShowConfirmDelete(false)}
          />
        )}
        {showDeleteSuccess && (
          <SweetAlert success title="Berhasil Dihapus" onConfirm={() => setShowDeleteSuccess(false)} btnSize="sm" />
        )}

        <Card>
          <Card.Header>
            <h4 className="card-title">Daftar User </h4>
          </Card.Header>
          <Card.Body>
            <div className="table-responsive border-bottom my-3">
              {loading ? (
                <div className="text-center p-4">
                  <Spinner animation="border" />
                </div>
              ) : (
                <DataTable
                  columns={columns}
                  data={paginatedData}
                  highlightOnHover
                  pagination
                  paginationServer
                  paginationPerPage={size}
                  paginationTotalRows={filteredData.length}
                  onChangePage={(newPage) => setPage(newPage - 1)}
                  onChangeRowsPerPage={(newSize) => { setSize(newSize); setPage(0); }}
                  customStyles={{
                    headCells: {
                      style: { backgroundColor: "#00acee", color: "white" },
                    },
                  }}
                />
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default DataUserTrader;